import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Button } from "./styles/Button.styled";

type CenteredToastOptions = {
  onConfirm?: () => void;
  duration?: number;
};

let showToast: (message: string, options?: CenteredToastOptions) => void;

export function CenteredToastContainer() {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [options, setOptions] = useState<CenteredToastOptions>({});

  useEffect(() => {
    showToast = (msg, opts) => {
      setMessage(msg);
      setOptions(opts || {});
      setVisible(true);

      if (opts?.duration) {
        setTimeout(() => setVisible(false), opts.duration);
      }
    };
  }, []);

  const handleClose = () => {
    setVisible(false);
    options?.onConfirm?.();
  };

  if (!visible) return null;

  return createPortal(
    <div className="centered-toast">
      <div className="centered-toast-main">
        <p>{message}</p>
        <Button onClick={handleClose}>Okay</Button>
      </div>
    </div>,
    document.body
  );
}

export function showCenteredToast(
  message: string,
  options?: CenteredToastOptions
) {
  if (showToast) {
    showToast(message, options);
  } else {
    console.warn("Toast system not ready yet.");
  }
}
